import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_se-power-solutions/artifacts/oxno8tfd_logofont.jpg" 
                alt="Studerus Electric Inc." 
                className="h-12 w-auto object-contain"
                style={{ 
                  filter: 'brightness(0) invert(1)',
                  opacity: '0.9'
                }}
              />
            </div>
            <p className="text-gray-400 mb-4">
              Professional electrical services serving London, Kingston, and surrounding areas in Ontario.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61581031466729" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-500 transition-colors"
                aria-label="Follow us on Facebook"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a 
                href="https://www.instagram.com/studeruselectric/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-500 transition-colors"
                aria-label="Follow us on Instagram"
              >
                <Instagram className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/residential" className="text-gray-400 hover:text-white transition-colors">
                  Residential Electrical
                </Link>
              </li>
              <li>
                <Link to="/services/commercial" className="text-gray-400 hover:text-white transition-colors">
                  Commercial Electrical
                </Link>
              </li>
              <li>
                <Link to="/services/fire-alarm" className="text-gray-400 hover:text-white transition-colors">
                  Fire Alarm Systems
                </Link>
              </li>
              <li>
                <Link to="/services/panel-upgrades" className="text-gray-400 hover:text-white transition-colors">
                  Panel Upgrades
                </Link>
              </li>
              <li>
                <Link to="/services/solar" className="text-gray-400 hover:text-white transition-colors">
                  Solar Installation
                </Link>
              </li>
              <li>
                <Link to="/services/ev-charging" className="text-gray-400 hover:text-white transition-colors">
                  EV Charger Installation
                </Link>
              </li>
              <li>
                <Link to="/services/generator-installation" className="text-gray-400 hover:text-white transition-colors">
                  Generator Installation
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Service Areas</h4>
            <ul className="space-y-2 text-gray-400">
              <li>London</li>
              <li>Kingston</li>
              <li>Windsor</li>
              <li>Chatham</li>
              <li>Sarnia</li>
              <li>Kitchener</li>
              <li>St Thomas</li>
              <li>Ingersoll</li>
              <li>Woodstock</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Information</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone className="h-5 w-5 text-yellow-500 mt-1" />
                <div>
                  <a href="tel:519-709-9242" className="text-gray-400 hover:text-white transition-colors">
                    519-709-9242
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-5 w-5 text-yellow-500 mt-1" />
                <div>
                  <a href="mailto:info@studeruselectric.com" className="text-gray-400 hover:text-white transition-colors">
                    info@studeruselectric.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-5 w-5 text-yellow-500 mt-1" />
                <div className="text-gray-400">
                  London, Ontario
                </div>
              </li>
            </ul>
              <div className="mt-4 text-sm text-gray-400">
              <p>Mon - Fri: 8:00 AM - 5:00 PM</p>
              <p>Sat: Closed</p>
              <p>Sun: Closed</p>
              <p className="mt-2">Emergency calls available evenings and weekends</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col items-center justify-center gap-4">
            {/* ECRA/ESA License */}
            <div className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_next-day-electric/artifacts/eg2m9qhz_ECRA-ESA-logo-color.png" 
                alt="ECRA/ESA" 
                className="h-12 w-auto object-contain"
              />
              <div className="text-white">
                <p className="font-semibold">ECRA/ESA Licence # 7013038</p>
              </div>
            </div>
            
            {/* Copyright and certifications */}
            <div className="text-center text-gray-400 text-sm">
              <p>© 2025 Studerus Electric Inc. All rights reserved.</p>
              <p className="mt-2">Fully Licensed & Insured | A+ BBB Rating | CommunityVotes London 2024 Winner - Best Electrician</p>
              <div className="mt-2">
                <Link 
                  to="/terms-and-conditions"
                  className="text-gray-400 hover:text-white transition-colors underline"
                >
                  Terms and Conditions
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;